(() => {
  const VERSION = '1.0.1';
  if (window.PBWCBPersonalizationCopyV1?.version === VERSION) return;

  const SAFE_DIMENSIONS_FALLBACK = 'The size guide image is temporarily unavailable. Sizes are listed as Length × Width × Height: length runs left to right across the front, width runs front to back, and height runs from the base to the top.';

  const sanitizeDimensionsFallback = () => {
    const fallback = document.querySelector('.pb-wedding-inline__dimensions-image-error');
    if (!fallback) return;

    fallback.textContent = SAFE_DIMENSIONS_FALLBACK;
    fallback.removeAttribute('aria-hidden');

    if (!fallback.dataset.pbWcbSafeFallback) {
      fallback.dataset.pbWcbSafeFallback = VERSION;
      new MutationObserver(() => {
        if (fallback.textContent !== SAFE_DIMENSIONS_FALLBACK) fallback.textContent = SAFE_DIMENSIONS_FALLBACK;
        if (fallback.getAttribute('aria-hidden') === 'true') fallback.removeAttribute('aria-hidden');
      }).observe(fallback, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }
  };

  let attempts = 0;
  const apply = () => {
    sanitizeDimensionsFallback();

    const root = document.querySelector('[data-pb-wedding-inline]');
    const details = root?.querySelector('[data-pb-personalization-details]');
    const field = details?.closest('.pb-wedding-inline__field');
    if (!details || !field) {
      attempts += 1;
      if (attempts < 100) setTimeout(apply, 60);
      return;
    }

    const label = field.querySelector(`label[for="${details.id}"]`) || field.querySelector('label');
    if (label) label.textContent = 'Enter your personalization details · Required';

    let instruction = field.querySelector('[data-pb-wcb-personalization-instruction]');
    if (!instruction) {
      instruction = document.createElement('small');
      instruction.dataset.pbWcbPersonalizationInstruction = '';
      instruction.style.display = 'block';
      instruction.style.margin = '-0.2rem 0 0.7rem';
      field.insertBefore(instruction, details);
    }
    instruction.textContent = 'Please provide the exact names, initials, date and/or wording you want included in your design.';

    details.placeholder = 'Example: Jenny & Kevin · September 12, 2026';

    const helpers = [...field.querySelectorAll(':scope > small')].filter(el => el !== instruction);
    const helper = helpers[helpers.length - 1];
    if (helper) helper.textContent = 'We’ll adapt these details to your selected design and send a digital mock-up for approval before production.';

    sanitizeDimensionsFallback();
    window.PBWCBPersonalizationCopyV1 = { version: VERSION, active: true };
  };

  apply();
})();
